import {css} from "@panda/css";

import {CheckboxMarkIcon} from "@pg-design/icons-module";
import {Switcher} from "@pg-design/switcher-module";
import {Text} from "@pg-design/text-module";
import {KM_HM_TEST_IDS} from "@pg-mono/test-ids";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";

const {SUMMARY} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;
const CONSENT_LABEL_ID = "home-match-preferences-wizard-consent-label";

interface IProps {
    consent: boolean;
    onConsentChange: (consent: boolean) => void;
}

export const HomeMatchPreferencesWizardSummaryConsent = (props: IProps) => {
    const {consent, onConsentChange} = props;

    return (
        <div className={consentCardStyle}>
            <div className={toggleStyle}>
                <Text as="span" className={consentTitleStyle} color="var(--colors-gray-900)" id={CONSENT_LABEL_ID} preserveFontSize variant="headline_7">
                    {SUMMARY.TOGGLE}
                </Text>

                <Switcher
                    aria-labelledby={CONSENT_LABEL_ID}
                    checked={consent}
                    checkedColor="var(--colors-secondary)"
                    dataTestId={KM_HM_TEST_IDS.PREFERENCES_WIZARD_SUMMARY_TOGGLE}
                    id="home-match-preferences-wizard-consent"
                    onChange={onConsentChange}
                />
            </div>

            <Text color="var(--colors-gray-800)" preserveFontSize variant="info_txt_1">
                {SUMMARY.CONSENT_INTRO}
            </Text>

            <ul className={consentListStyle}>
                {SUMMARY.CONSENT_ITEMS.map((item) => (
                    <li className={consentItemStyle} key={item}>
                        <CheckboxMarkIcon
                            className={checkIconStyle}
                            fill="var(--colors-secondary)"
                            size="1.05"
                            wrapperColor="var(--colors-background-200)"
                            wrapperSize="1.6"
                            wrapperType="circle"
                        />

                        <Text color="var(--colors-secondary)" preserveFontSize variant="info_txt_1">
                            {item}
                        </Text>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const consentCardStyle = css({
    backgroundColor: "var(--colors-background-50)",
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: 2
});

const consentTitleStyle = css({
    fontWeight: 600
});

const toggleStyle = css({
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
});

const consentListStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    listStyle: "none",
    m: 0,
    p: 0
});

const consentItemStyle = css({
    alignItems: "flex-start",
    display: "flex",
    gap: 1
});

const checkIconStyle = css({
    flexShrink: 0
});
import {css} from "@panda/css";

import {CheckboxMarkIcon} from "@pg-design/icons-module";
import {Switcher} from "@pg-design/switcher-module";
import {Text} from "@pg-design/text-module";
import {KM_HM_TEST_IDS} from "@pg-mono/test-ids";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";

const {SUMMARY} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;
const CONSENT_LABEL_ID = "home-match-preferences-wizard-consent-label";

interface IProps {
    consent: boolean;
    onConsentChange: (consent: boolean) => void;
}

export const HomeMatchPreferencesWizardSummaryConsent = (props: IProps) => {
    const {consent, onConsentChange} = props;

    return (
        <div className={consentCardStyle}>
            <div className={toggleStyle}>
                <Text as="span" className={consentTitleStyle} color="var(--colors-gray-900)" id={CONSENT_LABEL_ID} preserveFontSize variant="headline_7">
                    {SUMMARY.TOGGLE}
                </Text>

                <Switcher
                    aria-labelledby={CONSENT_LABEL_ID}
                    checked={consent}
                    checkedColor="var(--colors-secondary)"
                    dataTestId={KM_HM_TEST_IDS.PREFERENCES_WIZARD_SUMMARY_TOGGLE}
                    id="home-match-preferences-wizard-consent"
                    onChange={onConsentChange}
                />
            </div>

            <Text color="var(--colors-gray-800)" preserveFontSize variant="info_txt_1">
                {SUMMARY.CONSENT_INTRO}
            </Text>

            <ul className={consentListStyle}>
                {SUMMARY.CONSENT_ITEMS.map((item) => (
                    <li className={consentItemStyle} key={item}>
                        <CheckboxMarkIcon
                            className={checkIconStyle}
                            fill="var(--colors-secondary)"
                            size="1.05"
                            wrapperColor="var(--colors-background-200)"
                            wrapperSize="1.6"
                            wrapperType="circle"
                        />

                        <Text color="var(--colors-secondary)" preserveFontSize variant="info_txt_1">
                            {item}
                        </Text>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const consentCardStyle = css({
    backgroundColor: "var(--colors-background-50)",
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: 2
});

const consentTitleStyle = css({
    fontWeight: 600
});

const toggleStyle = css({
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
});

const consentListStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    listStyle: "none",
    m: 0,
    p: 0
});

const consentItemStyle = css({
    alignItems: "flex-start",
    display: "flex",
    gap: 1
});

const checkIconStyle = css({
    flexShrink: 0
});
